import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VRow,
        [
          _c(VCol, { attrs: { cols: "12" } }, [
            _c("h6", {
              staticClass: "title-modal",
              domProps: { innerHTML: _vm._s(_vm.composeName) },
            }),
          ]),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(
                VForm,
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.validform,
                    callback: function ($$v) {
                      _vm.validform = $$v
                    },
                    expression: "validform",
                  },
                },
                [
                  _c(
                    VTabs,
                    {
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c(
                        VTab,
                        {
                          on: {
                            click: function ($event) {
                              _vm.tabActive = "GENERAL"
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("my_tasks.modals.general")))]
                      ),
                      _c(
                        VTab,
                        {
                          on: {
                            click: function ($event) {
                              _vm.tabActive = "CONNECTIONS"
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("my_tasks.modals.connections")))]
                      ),
                      _c(
                        VTab,
                        {
                          on: {
                            click: function ($event) {
                              _vm.tabActive = "BUSINESS_TERM"
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("my_tasks.modals.bterm")))]
                      ),
                      _c(
                        VTab,
                        {
                          on: {
                            click: function ($event) {
                              _vm.tabActive = "LINEAGE"
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("my_tasks.modals.lineage")))]
                      ),
                      _c(
                        VTab,
                        {
                          on: {
                            click: function ($event) {
                              _vm.tabActive = "HISTORY_LOGS"
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("my_tasks.modals.hlogs")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    VTabsItems,
                    {
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c(
                        VTabItem,
                        { staticClass: "pt-2" },
                        [
                          _c("tab-general-view", {
                            ref: "tab_general",
                            attrs: {
                              item: _vm.item,
                              valid: _vm.valid,
                              readonly: _vm.readonly,
                              isChangeRequest: _vm.isChangeRequest,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VTabItem,
                        { staticClass: "pt-2" },
                        [
                          _c("tab-connection-view", {
                            attrs: { item: _vm.item, readonly: _vm.readonly },
                            on: { onShowTable: _vm.showTable },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VTabItem,
                        { staticClass: "pt-2" },
                        [
                          _c("tab-business-term-datasource", {
                            attrs: { item: _vm.item, readonly: _vm.readonly },
                            on: { onCancel: _vm.onCancel },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VTabItem,
                        [
                          _c("datasource-tab-lineage", {
                            attrs: { item: _vm.item },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VTabItem,
                        { staticClass: "pt-2" },
                        [
                          _c("tab-history-log-view", {
                            attrs: { item: _vm.item },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  [
                    _vm.ACCESS_TYPE_FLOW.APPROVE_OWNER,
                    _vm.ACCESS_TYPE_FLOW.CHANGE_METADATA,
                  ].includes(_vm.isChangeRequest) &&
                  _vm.tabActive !== "BUSINESS_TERM"
                    ? _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold pl-0" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.ACCESS_TYPE_FLOW.APPROVE_OWNER ===
                                        _vm.isChangeRequest
                                        ? _vm.$t("my_tasks.response_reason")
                                        : _vm.$t("my_tasks.response_request")
                                    )
                                  ),
                                ]
                              ),
                              _c(VTextarea, {
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "no-resize": "",
                                  rows: "3",
                                  rules: [
                                    function (v) {
                                      return (
                                        !!v ||
                                        _vm.$t("my_tasks.modals.required")
                                      )
                                    },
                                  ],
                                  placeholder:
                                    _vm.ACCESS_TYPE_FLOW.APPROVE_OWNER ===
                                    _vm.isChangeRequest
                                      ? _vm.$t("my_tasks.response_reason")
                                      : _vm.$t("my_tasks.response_request") +
                                        "...",
                                },
                                model: {
                                  value: _vm.response_text,
                                  callback: function ($$v) {
                                    _vm.response_text = $$v
                                  },
                                  expression: "response_text",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showButtons && _vm.tabActive !== "BUSINESS_TERM"
                    ? _c("div", { staticClass: "text-right mt-3" })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }